// import React from "react";
// import { Box, SimpleGrid, useColorMode } from "@chakra-ui/react";
// import "./Project.css";
// import image from "../assets/img/Sephora.png"
// import Beau from "../assets/img/Beau.png"
// import AD from "../assets/img/ApniDukan.png"
// import CD from "../assets/img/Cleardekho.png"
// import { FaGithub, FaEye } from "react-icons/fa";

 
//   const Projects = () => {

//   return (
//     <div
//       id="projects"
//       className="main_container"
//       style={{
//         // backgroundColor: "#edf2f8",
//         // backgroundColor: "#2c1e4a",
//         backgroundColor: "black",
//         color : "white"
//       }} 
//     >
//       <div className="project_container">
//         <div className="project_heading">
//           <h2 className="title">
//             Projects
//           </h2>
//         </div>

//         <div className="project_grid">
//           <SimpleGrid columns={[1, 1, 2, 3]} spacing="40px">

//             <Box>
//               <div 
//                 className="project_box project-card"
//                 style={{
//                   backgroundColor:  "#1a202c",
//                 }}
//               >
//                 <div className="project_image">
//                   <img src={CD} alt="Learning management" />
//                 </div>

//                 <div className="project_name project-title"   >
//                   <h2>Cleardekho</h2>
//                 </div>
//                 <div className="project_desc project-description"   >
//                   <p>
//                   "CLEARDEKHO" offer you the convenience of shopping for eyeglasses that you need for your eyes - be it eyeglasses, computer glasses, kids glasses, contact lens, sunglasses, eyeglasses frames from a single virtual store.
//                   </p>
//                 </div>
//                 <div className="project_tech_stack project-tech-stack"   >
//                   <h5>
//                     <span>Tech Stack :</span> React, Node, Express, Mongodb, Chakra UI
//                   </h5>
//                 </div>
//                 <div className="project_icon">
//                   <div className="github_link project-github-link"   >
//                     <a
//                       href="https://github.com/RutuvikP/shiny-blade-5949"
//                       rel="noopener norefferer"
//                       target="_blank"
                     
//                     >
//                       <FaGithub color="white" />
//                     </a>
//                   </div>
//                   <div className="deploy_link project-deployed-link"    >
//                     <a
//                       href="https://cleardekho-rutuvikp.vercel.app/"
//                       rel="noopener norefferer"
//                       target="_blank"
//                     >
//                       <FaEye color="white"/>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </Box>
//             <Box>
//               <div 
//                 className="project_box project-card"
//                 style={{
//                   backgroundColor:  "#1a202c",
//                 }}
//               >
//                 <div className="project_image">
//                   <img src={AD} alt="Learning managemen" />
//                 </div>

//                 <div className="project_name project-title"   >
//                   <h2>Apni Dukan</h2>
//                 </div>
//                 <div className="project_desc project-description"   >
//                   <p>
//                An E-Commerce Website : Clone of Dollar General (US based company)
//                   </p>
//                 </div>
//                 <div className="project_tech_stack project-tech-stack"   >
//                   <h5>
//                     <span>Tech Stack :</span>React, JavaScript, HTML, CSS
//                   </h5>
//                 </div>
//                 <div className="project_icon">
//                   <div className="github_link project-github-link"   >
//                     <a
//                       href="https://github.com/kumkumdutta/mean-part-5754"
//                       rel="noopener norefferer"
//                       target="_blank"
                     
//                     >
//                       <FaGithub color="white"/>
//                     </a>
//                   </div>
//                   <div className="deploy_link project-deployed-link"    >
//                     <a
//                       href="https://gentle-twilight-b8683d.netlify.app/"
//                       rel="noopener norefferer"
//                       target="_blank"
//                     >
//                       <FaEye color="white"/>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </Box>
//             <Box>
//               <div 
//                 className="project_box project-card"
//                 style={{
//                   backgroundColor:  "#1a202c",
//                 }}
//               >
//                 <div className="project_image">
//                   <img src={Beau} alt="Beau Skin" />
//                 </div>

//                 <div className="project_name project-title"   >
//                   <h2>Beau Skin </h2>
//                 </div>
//                 <div className="project_desc project-description"   >
//                   <p>
//                   This is one of the best project that I have made.Its an Indivisual Project completed withing 5 days.
//                   </p>
//                 </div>
//                 <div className="project_tech_stack project-tech-stack"   >
//                   <h5>
//                     <span>Tech Stack :</span>React, JavaScript, HTML, CSS, Chakra UI
//                   </h5>
//                 </div>
//                 <div className="project_icon">
//                   <div className="github_link project-github-link"   >
//                     <a
//                       href="https://github.com/AkshayKumarGaurav/awful-oatmeal-2681"
//                       rel="noopener norefferer"
//                       target="_blank"
                     
//                     >
//                       <FaGithub color="white"/>
//                     </a>
//                   </div>
//                   <div className="deploy_link project-deployed-link"    >
//                     <a
//                       href="https://stellar-melomakarona-cbaa46.netlify.app/"
//                       rel="noopener norefferer"
//                       target="_blank"
//                     >
//                       <FaEye color="white"/>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </Box>
//             <Box>
//               <div 
//                 className="project_box project-card"
//                 style={{
//                   backgroundColor:  "#1a202c",
//                 }}
//               >
//                 <div className="project_image">
//                   <img src={image} alt="Learning managemen" />
//                 </div>

//                 <div className="project_name project-title"   >
//                   <h2>Sephora</h2>
//                 </div>
//                 <div className="project_desc project-description"   >
//                   <p>
//                   Clone of the e-commerce website Sephora. Built on HTML, CSS & JavaScript. It's a solo project completed executed in 5 days.
//                   </p>
//                 </div>
//                 <div className="project_tech_stack project-tech-stack"   >
//                   <h5>
//                     <span>Tech Stack :</span> JavaScript, HTML, CSS
//                   </h5>
//                 </div>
//                 <div className="project_icon">
//                   <div className="github_link project-github-link"   >
//                     <a
//                       href="https://github.com/AkshayKumarGaurav/spacial-stew-9341"
//                       rel="noopener norefferer"
//                       target="_blank"
                     
//                     >
//                       <FaGithub color="white"/>
//                     </a>
//                   </div>
//                   <div className="deploy_link project-deployed-link"    >
//                     <a
//                       href="https://darling-druid-78ef30.netlify.app/index.html"
//                       rel="noopener norefferer"
//                       target="_blank"
//                     >
//                       <FaEye color="white"/>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </Box>

           
 
//           </SimpleGrid>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default Projects;

////////////////
/////////////////

// import React from 'react'
// import {
//   Stack,
//   Flex,
//   Button,
//   Text,
//   VStack,
//   useBreakpointValue,
//   Grid,
//   Box,
//   Image,
//   Icon,
//   Link,
//   Heading,
//   Center,
//   Badge,
// } from '@chakra-ui/react';
// import { FaGithub,FaGlobe } from "react-icons/fa";
// import { PropsWithChildren, Fragment } from 'react';
// import {
//   chakra,



//   HStack,

 

//   Container,

//   StackProps
// } from '@chakra-ui/react';
// // Here we have used react-icons package for the icons
// import { AiOutlineHeart, AiOutlineExclamationCircle } from 'react-icons/ai';
// import { BsTelephoneX } from 'react-icons/bs';
// let projects = [
//   {
//   image:"https://i.postimg.cc/5tjn9trH/fashionology.png",
//   name:"Fashionology",
//   descrition:'Fashionology, a clone of Anthropologie , is a website for Women Fashion',
//   techstack:['react','redux','chakraUI'],
//   github:'https://github.com/kumkumdutta/doubtful-quince-6370',
//   deployed:'https://fashionology.vercel.app/'

// },
//   {
//   image:'https://i.postimg.cc/j2k4D9jF/Dollar-general.png',
//   name:"Apni Dukan",
//   descrition:' Apni Dukan, a clone of Dollar general, is basically a website for grocery items.',
//   techstack:['HTML','CSS','Javascript'],
//   github:'https://github.com/kumkumdutta/mean-part-5754',
//   deployed:'https://gentle-twilight-b8683d.netlify.app/'

// },
//   {
//   image:"https://i.postimg.cc/VNNFZCkd/mecare.png",
//   name:"MeCare",
//   descrition:' Mecare, a website for fitness and massage products',
//   techstack:['react', 'redux', 'ChakraUi'],
//   github:'https://github.com/kumkumdutta/terrific-language-9098a',
//   deployed:'https://verdant-pasca-4e76c9.netlify.app/'

// },
//   {
//   image:"https://i.postimg.cc/MpYgCVbw/chalo-ghume.png",
//   name:"Chalo Ghume",
//   descrition:'Chalo ghume, is a clone of Expedia which is basically a travel website for booking hotel,car, flight or train.',
//   techstack:['react','redux','ChakraUI'],
//   github:'https://github.com/kumkumdutta/interesting-stretch-8935',
//   deployed:'https://interesting-stretch-8935.vercel.app/'

// },
// ]
// export const Projects = () => {
  
//     return (
//       <Box bgColor={'#B3E5FC'} backgroundSize='cover' display={'flex'} flexDirection={'column'} width={'100%'} p="50px">
//         <Text color={'white'} fontWeight={'bold'} fontSize={'3xl'}>Projects</Text>
//         {/* <Grid p='30px' placeItems={'center'} templateColumns={{ base: 'repeat(1, 1fr)',  md: 'repeat(2, 1fr)',lg:'repeat(2, 2fr)'}}  columnGap={20} rowGap={10} mt={'60px'} borderRadius={'20px'}
//       id="projects"
//         > */}
//           <Container maxW="7xl" p={{ base: 5, md: 12 }} margin="0 auto">
//       <VStack spacing={8}>
//         {projects.map((product, index) => (
//           <Stack
//             key={index}
//             spacing={{ base: 0, md: 4 }}
//             direction={{ base: 'column', md: 'row' }}
//             border="1px solid "
//             boxShadow= 'rgba(0, 0, 0, 0.35) 0px 5px 15px;'
//             borderColor="gray.400"
//             p={2}
//             rounded="md"
//             w={{ base: 'auto', md: '6xl' }}
//             h={{ base: 'auto', md: '250px' }}
//             overflow="hidden"
//             pos="relative"
//           >
            
//             <Flex ml="0 !important">
//               <Image
//                 rounded="md"
//                 w={{ base: '100%', md: '18rem',lg:'35rem'}}
//                 h="auto"
//                 objectFit="cover"
//                 src={product.image}
//                 alt="product image"
//               />
//             </Flex>
//             <Stack direction="column" spacing={2} w="100%" mt={{ base: '5px !important', sm: 0 }}>
//               <Flex justify="space-between">
//                 <chakra.h3 fontSize={{ base: 'lg', md: 'xl' ,lg:'2xl'}} fontWeight="bold">
//                   {product.name}
//                 </chakra.h3>
               
//               </Flex>
//               <Box>
//               <Text textAlign={'initial'} fontSize={{ base: 'sm', sm: 'md',lg:'lg' }}>{product.descrition}</Text>
//               </Box>
//               <Flex alignItems="center" color="gray.500">
//                 {product.techstack.map((data, index) => (
//                   <Fragment key={index}>
//                     <Text fontSize={{ base: 'sm', sm: 'md',lg:'lg' }}>{data}</Text>
//                     {product.techstack.length - 1 != index && (
//                       <chakra.span mx={2} fontSize={{ base: 'sm', sm: 'md' }}>
//                         |
//                       </chakra.span>
//                     )}
//                   </Fragment>
//                 ))}
//               </Flex>
//               <Stack
//                 direction={{ base: 'column-reverse', sm: 'row' }}
//                 justify="space-between"
//                 alignItems={{ base: 'flex-start', sm: 'center' }}
//               >
                
//                 <Stack direction="row" spacing={1} mb="0 !important">
//                   <Link href={product.github}>
//                   <IconButton>
//                     <Icon as={FaGithub} w={6} h={6} />
//                   </IconButton></Link>
//                  <Link href={product.deployed}>
//                  <IconButton spacing={2} >
//                     <Icon as={FaGlobe} w={6} h={6} />
                    
//                   </IconButton>
//                  </Link>
                 
//                 </Stack>
//               </Stack>
//             </Stack>
//           </Stack>
//         ))}
//       </VStack>
//     </Container>
          
        
      
        

      
        
      
//         {/* <Stack className="project-card"
//           borderWidth="1px"
//           borderRadius="lg"
//           w={{ sm: '100%', md: '540px' }}
//           height={{ sm: '476px', md: '20rem' }}
//           direction={{ base: 'column', md: 'row' }}
          
//           boxShadow={'2xl'}
//           padding={4}>
//           <Flex flex={1} bg="blue.200">
//             <Image
//               objectFit="cover"
//               boxSize="100%"
//               src='https://i.postimg.cc/MpYgCVbw/chalo-ghume.png'
//             />
//           </Flex>
//           <Stack
//             flex={1}
//             flexDirection="column"
//             justifyContent="center"
//             alignItems="center"
//             p={1}
//             pt={2}>
//             <Heading color={'white'} fontSize={'2xl'} fontFamily={'body'} className="project-title">
//              Chalo Ghume
//             </Heading>
            
//             <Text
//               textAlign={'center'}
//               className="project-description"
//               px={3} color={'white'}>
//               Chalo ghume, is a clone of Expedia which is basically a travel website for booking hotel,car, flight or train.
              
//             </Text>
//             <Stack align={'center'} justify={'center'} direction={'row'} mt={6} className="project-tech-stack">
//               <Badge
//                 px={2}
//                 py={1}
                
//                 fontWeight={'400'}>
//                 #react
//               </Badge>
//               <Badge
//                 px={2}
//                 py={1}
                
//                 fontWeight={'400'}>
//                 #redux
//               </Badge>
//               <Badge
//                 px={2}
//                 py={1}
               
//                 fontWeight={'400'}>
//                 #Chakra Ui
//               </Badge>
//             </Stack>
  
//             <Stack
//               width={'100%'}
//               mt={'2rem'}
//               direction={'row'}
//               padding={2}
//               justifyContent={'space-between'}
//               alignItems={'center'}>
//               <Button
//                 flex={1}
//                 fontSize={'sm'}
//                 rounded={'full'}
//                 _focus={{
//                   bg: 'gray.200',
//                 }}>
//                   <Link href='https://github.com/kumkumdutta/interesting-stretch-8935' className="project-github-link">Github</Link>
                
//               </Button>
//               <Button
//                 flex={1}
//                 fontSize={'sm'}
//                 rounded={'full'}
//                 bg={'blue.400'}
//                 color={'white'}
//                 boxShadow={
//                   '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
//                 }
//                 _hover={{
//                   bg: 'blue.500',
//                 }}
//                 _focus={{
//                   bg: 'blue.500',
//                 }}>
//                   <Link href='https://interesting-stretch-8935.vercel.app/' className="project-deployed-link">Deployed</Link>
                
//               </Button>
//             </Stack>
//           </Stack>
//         </Stack>
//       */}

//       {/* </Grid> */}

//       </Box>
      
//     );
 
// }

// const IconButton = ({ children, ...props }) => {
//   return (
//     <HStack
//       cursor="pointer"
//       border="1px solid"
//       borderColor="gray.300"
//       px={2}
//       py="0.15rem"
//       alignItems="center"
//       rounded="sm"
//       spacing={2}
//       {...props}
//     >
//       {children}
//     </HStack>
//   );
// };
////////
////////

// import image from "../assets/img/Sephora.png"
// import Beau from "../assets/img/Beau.png"
// import AD from "../assets/img/ApniDukan.png"
// import CD from "../assets/img/Cleardekho.png"
// import '../App.css';
// import { PropsWithChildren, Fragment } from 'react';
// import {
//   chakra,
//   Box,
//   Stack,
//   VStack,
//   HStack,
//   Flex,
//   Text,
//   Image,
//   Container,
//   Icon,
//   StackProps
// } from '@chakra-ui/react';
// // Here we have used react-icons package for the icons
// import { AiOutlineHeart, AiOutlineExclamationCircle } from 'react-icons/ai';
// import { BsTelephoneX } from 'react-icons/bs';


// let projects = [
//     {
//     image:'https://i.postimg.cc/ydrc6csP/Screenshot-1940.png',
//     name:"Cleardekho",
//     descrition:'"CLEARDEKHO" offer you the convenience of shopping for eyeglasses that you need for your eyes - be it eyeglasses, computer glasses, kids glasses, contact lens, sunglasses, eyeglasses frames from a single virtual store.',
//     techstack:['HTML5', 'CSS3', 'React', 'Node', 'Express', 'Mongodb', 'Chakra UI'],
//     github:'https://github.com/RutuvikP/shiny-blade-5949',
//     deployed:'https://cleardekho-rutuvikp.vercel.app/'
  
//   },
//     {
//     image:'https://i.postimg.cc/j2k4D9jF/Dollar-general.png',
//     name:"Apni Dukan",
//     descrition:' Apni Dukan, a clone of Dollar general, is basically a website for grocery items.',
//     techstack:['HTML','CSS','Javascript'],
//     github:'https://github.com/kumkumdutta/mean-part-5754',
//     deployed:'https://gentle-twilight-b8683d.netlify.app/'
  
//   },
//     {
//     image:"https://i.postimg.cc/VNNFZCkd/mecare.png",
//     name:"Beau Skin",
//     descrition:' This is one of the best project that I have made.Its an Indivisual Project completed withing 5 days.',
//     techstack:['HTML5', 'CSS3', 'JavaScript', 'react', 'redux', 'ChakraUi'],
//     github:'https://github.com/AkshayKumarGaurav/Beau-Skin-Skin_Store-Clone',
//     deployed:'https://stellar-melomakarona-cbaa46.netlify.app/'
  
//   },
//     {
//     image:"https://akshaykumargaurav.github.io/static/media/Sephora.8550a0943f1bbd90baaf.png",
//     name:"Sephora",
//     descrition:'Clone of the e-commerce website Sephora. Built on HTML, CSS & JavaScript. It is a solo project completed executed in 5 days.',
//     techstack:['HTML5','CSS3', 'JavaScript', 'Local-Storage'],
//     github:'https://github.com/AkshayKumarGaurav/Sephora-clone',
//     deployed:'https://darling-druid-78ef30.netlify.app/index.html'
  
//   },
//   {
//     image:"https://drive.google.com/file/d/19ns7SA4WNfUb0bmAGBh5kbh6hAThsUKe/view?usp=sharing",
//     name:"Code Converter",
//     descrition:'A web tool for code conversion between programming languages, debugging, and code quality checks. Simplify coding tasks and enhance your development workflow.',
//     techstack:['HTML5','CSS3', 'JavaScript', 'React', 'Node.js', 'Express.js', 'OpenAI', 'Octokit','Chakra-UI','Github-API'],
//     github:'https://github.com/AkshayKumarGaurav/code-converter',
//     deployed:'https://codeconv.netlify.app/'
  
//   },
//   ]

// const Projects = () => {
//   return (
//     <Box w={'80%'} m={'auto'} p={'20px'}>
//       <Text className="title">Projects</Text>
//       <Container maxW="7xl" p={{ base: 5, md: 12 }} margin="0 auto">
//       <VStack spacing={40}>
//         {projects.map((product, index) => (
//           <Stack
//             key={index}
//             spacing={{ base: 0, md: 4 }}
//             direction={{ base: 'column', md: 'row' }}
//             border="1px solid"
//             borderColor="gray.400"
//             p={2}
//             rounded="md"
//             w={{ base: 'auto', md: '2xl' }}
//             overflow="hidden"
//             pos="relative"
//           >
//             <Flex ml="0 !important">
//               <Image
//                 rounded="md"
//                 w={{ base: '100%', md: '18rem' }}
//                 h="auto"
//                 objectFit="cover"
//                 src={product.image}
//                 alt="product image"
//               />
//             </Flex>
//             <Stack direction="column" spacing={2} w="100%" mt={{ base: '5px !important', sm: 0 }}>
//               <Flex justify="space-between">
//                 <chakra.h3 fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">
//                   {product.name}
//                 </chakra.h3>
//               </Flex>
//               <Box>
//                 <Text fontSize="lg" fontWeight="500">
//                   {product.descrition}
//                 </Text>
//               </Box>
//               <Flex alignItems="center" color="gray.500">
//                 {product.techstack.map((data, index) => (
//                   <Fragment key={index}>
//                     <Text fontSize={{ base: 'sm', sm: 'md' }}>{data}</Text>
//                   </Fragment>
//                 ))}
//               </Flex>
//               <Stack
//                 direction={{ base: 'column-reverse', sm: 'row' }}
//                 justify="space-between"
//                 alignItems={{ base: 'flex-start', sm: 'center' }}
//               >
//                 <Stack direction="row" spacing={1} mb="0 !important">
//                   <IconButton>
//                     <Icon as={AiOutlineHeart} w={4} h={4} />
//                   </IconButton>
//                   <IconButton spacing={2} bg="green.500" color="white">
//                     <Icon as={BsTelephoneX} w={4} h={4} />
//                     <Text fontSize="sm">Show Phone no.</Text>
//                   </IconButton>
//                 </Stack>
//               </Stack>
//             </Stack>
//           </Stack>
//         ))}
//       </VStack>
//     </Container>
//     </Box>
//   );
// };

// const IconButton = ({ children, ...props }) => {
//   return (
//     <HStack
//       cursor="pointer"
//       border="1px solid"
//       borderColor="gray.300"
//       px={2}
//       py="0.15rem"
//       alignItems="center"
//       rounded="sm"
//       spacing={2}
//       {...props}
//     >
//       {children}
//     </HStack>
//   );
// };

// export default Projects;

/////

import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
 const Projects = () => {
  return (
    <>
      <div id="projects" className="section">
        <h2 className="section__title_different" data-aos="fade-right">
          Projects
        </h2>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/AkshayKumarGaurav/Form_validation/blob/master/assets/codeconverter.png?raw=true"
                  alt="Code Converter"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Code Converter</h2>
              <p>
              A web tool for code conversion between programming languages, debugging, and code quality checks. Simplify coding tasks and enhance your development workflow.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
                <SiExpress />
              </div>
              <div>
                <a
                  href="https://codeconv.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/AkshayKumarGaurav/code-converter"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/AkshayKumarGaurav/Form_validation/blob/master/assets/Cleardekho.png?raw=true"
                  alt="CLEARDEKHO"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>CLEARDEKHO</h2>
              <p>
                It is a clone of Lenkart. First Backend Project with NodeJS, ExpressJS and MongoDB. Used EJS to render views. Main functionalities were : Register/Login using JWT, Sorting and Filtering in the backend, Cart and Wish List and many more.
              </p>
              <div>
                <SiHtml5 />
                <IoLogoJavascript />
                <FaReact />
                <SiNodedotjs />
                <SiExpress />
                <SiMongodb />
              </div>
              <div>
                <a
                  href="https://cleardekho-rutuvikp.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/RutuvikP/ClearDekho-Lenskart-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/AkshayKumarGaurav/Form_validation/blob/master/assets/travelAtEase.png?raw=true"
                  alt=""
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Travel At Ease</h2>
              <p>
              This website is a clone of Orbitz, where user can book hotels, flights and users can also find some special/famous places in a city, where they should go and it is done by just checking our Thing To Do page.
              </p>
              <div>
              <SiHtml5 />
              <DiCss3 />
              <IoLogoJavascript />
              <FaReact />
              </div>
              <div>
                <a
                  href="https://travelatease.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/AkshayKumarGaurav/Travel-At-Ease"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/AkshayKumarGaurav/Form_validation/blob/master/assets/Beau.png?raw=true"
                  alt="Beau Skin"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Beau Skin</h2>
              <p>
              It is skin care e-commerce website, where you can find varity of skin care product(natural product).
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://stellar-melomakarona-cbaa46.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/AkshayKumarGaurav/Beau-Skin-Skin_Store-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://github.com/AkshayKumarGaurav/Form_validation/blob/master/assets/Sephora.png?raw=true"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Sephora</h2>
              <p>
              This website is a clone of Sephora, where user can buy beauty based product. A leader in luxury beauty and skincare, the purpose at Sephora online India is to create an inviting online beauty shopping experience and inspire fearlessness in our community.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://darling-druid-78ef30.netlify.app/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/AkshayKumarGaurav/Sephora-clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;